module.exports = __webpack_public_path__ + "static/media/24UHCHR19.e8e0a37c.jpg";